// @ts-nocheck
import React from 'react';
import { reactLazyRetry } from '../../utils/Utils';
import { DEFAULT_ROUTE_CONFIG } from '../../const/defaultRoutesConfig';

const ReportAndDashboard = reactLazyRetry(
  () => import('./pages/ReportAndDashboard')
);
const CreateReport = reactLazyRetry(() => import('./pages/CreateReport'));
const DashboardBuilderPage = reactLazyRetry(
  () => import('./pages/DashboardBuilderPage')
);
const ViewReport = reactLazyRetry(() => import('./pages/ViewReport'));
const ViewReportHistory = reactLazyRetry(
  () => import('./pages/ViewReportHistory')
);
const ViewDashboard = reactLazyRetry(() => import('./pages/ViewDashboard'));

/**
 * Report and Dashboard route definitions and metadata used by the
 * application router and permission-aware navigation (QuickLinks).
 */
export const reportAndDashboardRoutes = [
  {
    name: 'Reports and Dashboards',
    key: 'reportsAndDashboards',
    path:
      DEFAULT_ROUTE_CONFIG?.reportsAndDashboards?.path ||
      'reports-and-dashboards',
    element: <ReportAndDashboard />,
    permission: 'ReportAndDashboard',
    quickLink: {
      enabled: true,
      action: 'list',
    },
    children: [
      {
        name: 'Create Report',
        key: 'createReport',
        path:
          DEFAULT_ROUTE_CONFIG?.createReport?.path ||
          'reports-and-dashboards/create-report',
        element: <CreateReport />,
        permission: 'ReportAndDashboard_createReport',
        quickLink: {
          enabled: true,
          action: 'create',
        },
      },
      {
        name: 'Create Dashboard',
        key: 'createDashboard',
        path:
          DEFAULT_ROUTE_CONFIG?.createDashboard?.path ||
          'reports-and-dashboards/create-dashboard',
        element: <DashboardBuilderPage />,
        permission: 'ReportAndDashboard_createDashboard',
        quickLink: {
          enabled: true,
          action: 'create',
        },
      },
      {
        name: 'Edit Dashboard',
        key: 'editDashboard',
        path:
          DEFAULT_ROUTE_CONFIG?.editDashboard?.path ||
          'reports-and-dashboards/edit-dashboard/:dashboardId',
        element: <DashboardBuilderPage />,
        permission: 'ReportAndDashboard_editDashboard',
        quickLink: {
          enabled: true,
          action: 'update',
          resourceType: 'dashboard',
          resourceIdParam: 'dashboardId',
          dynamicTitle: true,
        },
      },
      {
        name: 'View Report',
        key: 'viewReport',
        path:
          DEFAULT_ROUTE_CONFIG?.viewReport?.path ||
          'reports-and-dashboards/view-report/:reportId',
        element: <ViewReport />,
        permission: 'ReportAndDashboard_viewReport',
        quickLink: {
          enabled: true,
          title: 'View Report',
          action: 'view',
          resourceType: 'report',
          resourceIdParam: 'reportId',
          dynamicTitle: true,
        },
      },
      {
        name: 'View Report History',
        key: 'viewReportHistory',
        path:
          DEFAULT_ROUTE_CONFIG?.viewReportHistory?.path ||
          'reports-and-dashboards/view-report/:reportId/history/:runId',
        element: <ViewReportHistory />,
        permission: 'ReportAndDashboard_viewReportHistory',
        quickLink: {
          enabled: true,
          title: 'Report History',
          action: 'history',
          resourceType: 'report',
          resourceIdParam: 'reportId',
          dynamicTitle: true,
        },
      },
      {
        name: 'View Dashboard',
        key: 'viewDashboard',
        path:
          DEFAULT_ROUTE_CONFIG?.viewDashboard?.path ||
          'reports-and-dashboards/view-dashboard/:dashboardId',
        element: <ViewDashboard />,
        permission: 'ReportAndDashboard_viewDashboard',
        quickLink: {
          enabled: true,
          title: 'View Dashboard',
          action: 'view',
          resourceType: 'dashboard',
          resourceIdParam: 'dashboardId',
          dynamicTitle: true,
        },
      },
    ],
  },
];
